var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"wrapper login_wrapper"},[_c('div',{staticClass:"login"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }